module.exports = __webpack_public_path__ + "img/dashboard.49d3bdb3.png";